var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.iconSrc)}}),_c('h3',[_vm._v(_vm._s(_vm.$t('loading.loading')))])])}
var staticRenderFns = []

export { render, staticRenderFns }